module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signatures-two-column"
  }, [_c('div', {
    staticClass: "signature-wrapper signature-left"
  }, [_c('document-part-signature', {
    attrs: {
      "signatures": _vm.signatures,
      "payload": _vm.signatureHolders[0],
      "state": _vm.state,
      "viewer": _vm.viewer
    },
    on: {
      "update": _vm.update
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "signature-wrapper signature-right"
  }, [_c('document-part-signature', {
    attrs: {
      "signatures": _vm.signatures,
      "payload": _vm.signatureHolders[1],
      "state": _vm.state,
      "viewer": _vm.viewer
    },
    on: {
      "update": _vm.update
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e439ad96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/signatures.vue
// module id = 551
// module chunks = 0